import Swiper, { Pagination } from 'swiper';
document.addEventListener('DOMContentLoaded', function () {
    const testimonialsSwiperEls = document.querySelectorAll('.testimonials-swiper');
    Array.from(testimonialsSwiperEls).forEach(el => {
        new Swiper(el, {
            modules: [Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: true,
            // Prevent accidental trackpad sliding
            threshold: 4,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
            autoplay: {
                delay: 5000,
            },
            loop: true,
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    });
});
